import { render } from "./MenuInstructor.vue?vue&type=template&id=152cfc1e&scoped=true"
import script from "./MenuInstructor.vue?vue&type=script&lang=js"
export * from "./MenuInstructor.vue?vue&type=script&lang=js"

import "./MenuInstructor.vue?vue&type=style&index=0&id=152cfc1e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152cfc1e"]])

export default __exports__